import type { Document } from '@contentful/rich-text-types';

import { usePetitionGuidesPageData } from 'src/app/pages/petitionGuidesArticle/pageContext';

type Result = ModelHookResult<{
	content: Document;
	contentLinks: Array<{ id?: string | null; displayText?: string | null }>;
	redirectUrl?: string;
}>;

export function usePageBody(): Result {
	const {
		data: {
			article: { content, contentLinksSection, redirectSlug },
		},
	} = usePetitionGuidesPageData();

	return {
		data: {
			content: content?.json as Document,
			contentLinks:
				contentLinksSection
					?.map((link) => ({
						id: link.id ?? link.contentSlug,
						displayText: link.displayText,
					}))
					.filter(({ displayText }) => displayText !== null) ?? [],
			redirectUrl: redirectSlug ? `/petition-guides/${redirectSlug}` : undefined,
		},
	};
}
